import { getCookie } from '@libs/utils/helpers/getSafeCookies';

/**
 * A/B test for the Sorting Credit vs Sorting Hat recommendation engine.
 * Default (no cookie) keeps the Sorting Hat behavior.
 * The variant routes the SHProvider baseURL to Sorting Credit.
 * @returns {Object} An object containing the function to check the Sorting Credit variant.
 */

const sortingCreditExperiment = () => {
  const testCookieName = 'dx-sortingcredit-v2';

  const variants = {
    '0': 'default',
    '1': 'with-sortingcredit',
  };

  const resultIsWithSortingCredit = () => {
    const currentResult = getCookie(testCookieName, false);

    if (!currentResult) return false;

    return currentResult.includes(variants[1]);
  };

  return {
    resultIsWithSortingCredit,
  };
};

export default sortingCreditExperiment;
